import { render, staticRenderFns } from "./Iot.vue?vue&type=template&id=f0871174&"
import script from "./Iot.vue?vue&type=script&lang=js&"
export * from "./Iot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports